import { useRef } from "react";
import { BoxProps, Flex, Grid, useBreakpointValue } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { ITraderWhoReacted } from "src/api/client/news/news-traders-reactions.api.types";
import { Button } from "src/components/base/button";
import { IconCaret } from "src/components/icons";
import { useExpandableElements } from "src/hooks/dom/use-expandable-elements";
import { EnumReactionArrowIndicator, ReactionArrowIndicator } from "./reaction-arrow-indicator";
import { TraderWhoReacted } from "./trader-who-reacted";

const DEFAULT_INITIAL_MAX_HEIGHT = 48;
const MOBILE_INITIAL_MAX_HEIGHT = 120;

interface ITradersWhoReacted extends BoxProps {
    variantReactionArrowIndicator: EnumReactionArrowIndicator;
    traders: ITraderWhoReacted[];
}

export const TradersWhoReacted = ({ traders, variantReactionArrowIndicator, ...boxProps }: ITradersWhoReacted) => {
    const ref = useRef<HTMLDivElement>(null);
    const { t } = useTranslation("news");
    const isMobile = useBreakpointValue([true, false]);
    const { isExpandable, isExpanded, showAll } = useExpandableElements({
        ref,
        maxHeight: isMobile ? MOBILE_INITIAL_MAX_HEIGHT : DEFAULT_INITIAL_MAX_HEIGHT,
    });

    return (
        <Flex flexFlow="column" {...boxProps}>
            <ReactionArrowIndicator variant={variantReactionArrowIndicator} pb={2} />
            <Grid
                gridTemplateColumns={["repeat(1, 1fr)", "repeat(2, 1fr)"]}
                gap="4"
                ref={ref}
                rowGap={[3, 2]}
                flexWrap="wrap"
                pos="relative"
                overflow="hidden"
                transition="height 0.3s"
                mb={3}
                maxHeight={isExpanded ? "unset" : `${isMobile ? MOBILE_INITIAL_MAX_HEIGHT : DEFAULT_INITIAL_MAX_HEIGHT}px`}
            >
                {traders.map(traderInfo => (
                    <TraderWhoReacted key={traderInfo.trader.id} traderInfo={traderInfo} />
                ))}
            </Grid>

            {isExpandable && (
                <Button size="sm" colorScheme="whiteAlpha" alignSelf="end" onClick={showAll} leftIcon={<IconCaret boxSize={3} />}>
                    {t("buttons.view-all")}
                </Button>
            )}
        </Flex>
    );
};
